import { IMap } from "@/Common/Models/IMap";
import { RvqDomainValue } from "../Models/RvqDomainValue";

class GetValuesResponse {
    public Cities?: IMap<RvqDomainValue>;
    public Provinces?: IMap<RvqDomainValue>;
    public Antigens?: IMap<RvqDomainValue>;
    public Types?: IMap<IMap<RvqDomainValue>>;

    public Issues?: string[];

    public static empty(): GetValuesResponse {
        return {
            Cities: {},
            Provinces: {},
            Antigens: {},
            Types: {},
            Issues: []
        };
    }
}

export { GetValuesResponse };
